import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translation from '../../shared/Translation';

class ReceiptUrl extends Component {
    render() {
        return(
            <div className="confirmation-reservation__delivery-link">
                <a className='link--unstyled' target="_blank" href={this.props.url}>
                    <Translation>{'checkout__click_to_view_full_receipt'}</Translation>
                </a>
            </div>
        )
    }
}

ReceiptUrl.propTypes = {
    url: PropTypes.string,
}

export default ReceiptUrl;
